<template>
    <v-container
        fluid
    >
        <v-row
            align="center"
            justify="center"
        >
            <img
                height="150"
                width="300"
                src="/soundanalytics.svg"
            >
        </v-row>
        <v-row
        no-gutters
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto my-12"
                    max-width="400"
                >
                    <v-card-title>
                        Recuperar contraseña
                    </v-card-title>
                    <v-card-text v-if="isCode">
                      <v-text-field
                          label="Correo electrónico"
                          type="text"
                          outlined
                          dense
                          v-model="email"
                          :rules="emailRules"
                          required
                      ></v-text-field>

                      <pin-input 
                          v-model="pinCode"
                          @complete="onComplete"
                      />
                    </v-card-text>
                    <v-card-text v-else>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                            <v-text-field
                                id="password"
                                label="Nueva contraseña"
                                name="password"
                                v-model="password"
                                :rules="passRules"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                outlined
                                dense
                                required
                            ></v-text-field>

                            <v-text-field
                                id="password"
                                label="Confirmacion nueva contraseña"
                                name="password"
                                v-model="confirmPassword"
                                :rules="confirmPasswordRules"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                outlined
                                dense
                                required
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-if="isCode">
                        <v-btn
                            width="95%"
                            color="success"
                            class="ma-2"
                            @click="resendCode"
                        >
                            Solicitar nuevo código
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-else>
                        <v-btn
                            v-if="!successRecover"
                            width="95%"
                            color="success"
                            class="ma-2"
                            :disabled="!valid"
                            @click="validate"
                        >
                            Cambiar
                        </v-btn>
                        <v-btn
                            v-else
                            width="95%"
                            color="success"
                            class="ma-2"
                            :disabled="!valid"
                            to="/login"
                        >
                            Ir a Login
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="end"
            justify="center"
        >
            <p class="font-weight-light">
                Copyright © {{currentYear}} — SoundAnalytics 
            </p>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment'

import PinInput from '../components/PinInput'
export default {
    name: 'Login',

    data: () => ({
        mode: 'code',
        email: '',
        pinCode: '',
        valid: false,
        show1: true,
        passRules: [
            v => !!v || 'Password es requerido',
        ],
        emailRules: [
            v => !!v || 'E-mail es requerido',
            v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
        ],
        password: '',
        confirmPassword: ''
    }),

    methods: {
        validate () {
            const isValid = this.$refs.form.validate()

            if (!isValid)
                return
            
            const payload = {
                password: this.password,
                token: this.token
            }
            
            this.$store.dispatch('recover', payload)
        },

        async onComplete(code) {
            try {
                const response = await this.$store.dispatch('sendEmailCode', {
                    type: 'recoverpass',
                    email: this.email,
                    code: code
                })
                
                if (!response)
                    return

                this.token = response
                this.mode = 'create'
                console.log(response)
            } catch (error) {
                console.log(error)
            }
        },

        async resendCode () {
            try {
                await this.$store.dispatch('sendEmailReSendCode', {
                    email: this.email,
                    type: "recoverpass"
                })
            } catch (error) {
                console.log(error)
            }
        },

        urlEmail () {
            try {
                const userB64 = this.$route.query.user
                const user = atob(userB64)
                const isEmail = user.includes('@')

                if (isEmail)
                    this.email = user
            } catch (error) {}
        },
    },

    computed: {
        isCode () {
            return this.mode === 'code'
        },
        errorRecover () {
            return this.$store.getters.errorRecover
        },
        successRecover () {
            return this.$store.getters.successRecover
        },
        currentYear () {
            return moment().format("YYYY")
        },
        confirmPasswordRules() {
            return [
                v => !!v || 'Confirmar password',
                v => v === this.password || 'Password no coinciden',
            ]
        },
    },

    watch : {
        loggedIn (val) {
            if (val)
                this.$router.push('/')
        }
    },

    components: {
        PinInput
    },

    created () {
        this.urlEmail()
        moment.locale('es-us')
    }

}
</script>
